import React from 'react'
import styles from './SignupVerificationForm.module.scss'
import SelfVerification from './components/SelfVerification/SelfVerification'
import { useState } from 'react'
import ToggleButtonGroup from '../../components/ToggleButtonGroup/ToggleButtonGroup'
import MembershipNumber from './components/MembershipNumber/MembershipNumber'
import RegisterNoticeModal from './components/modal/RegisterNoticeModal'
// import { certificationNice } from '../../../../utils/niceApi'
import { userTypes } from '../../utils'
import { useForm, Controller } from 'react-hook-form'
import { useCallback, useEffect } from 'react'
import ToggleButtonGroupController from '../../components/ToggleButtonGroup/ToggleButtonGroupController'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthStatus } from '../../utils'
import { useStateMachine } from 'little-state-machine'
import { updateStore } from '../../store'
import { registerTourPro, signin } from '../../services/api'
import axios from 'axios'
const returnURL = `${window.location.origin}/certify/complete`

const SignupVerificationForm = () => {
	const [verifiedStatus, setVerifiedStatus] = useState('notTried') // 본인인증 상태만 관리
	const [memberNumStatus, setMemberNumStatus] = useState('notTried') // 회원번호 인증 상태 관리
	const [submitType, setSubmitType] = useState(0)
	const [isModalOpened, setIsModalOpened] = useState(false)
	const location = useLocation()
	const [niceVerifiedUserInfo, setNiceVerifiedUserInfo] = useState(null)
	const navigate = useNavigate()
	const [auth, handleLogout, setAuth] = useAuthStatus()

	// Store
	const { actions, state } = useStateMachine({ updateStore })

	const {
		control,
		handleSubmit,
		register,
		watch,
		trigger,
		setValue,
		formState: { errors, isValid },
		clearErrors,
	} = useForm({
		mode: 'onSubmit', // 유효성 검사를 할 곳이 회원번호 5-8자리 보다 적게 입력하는 경우 말고 없음
		defaultValues: {
			association: 'KPGA',
			memberNumber: '',
			name: '',
			phoneNumber: '',
		},
	})

	// 멤버 넘버를 제외한 유효성 검사를 위한 커스텀 함수
	const handleSubmitWithoutMemberNumber = useCallback(
		(onSubmit) => {
			return () => {
				// 현재 폼 데이터 가져오기
				const currentData = watch()

				// memberNumber를 제외한 필드들만 검증
				const { memberNumber, ...dataWithoutMemberNumber } = currentData

				// 필수 필드들이 모두 있는지 확인
				if (
					dataWithoutMemberNumber.name &&
					dataWithoutMemberNumber.phoneNumber &&
					dataWithoutMemberNumber.association
				) {
					onSubmit(currentData)
				}
			}
		},
		[watch],
	)

	const onSubmitFinalData = async (data, typeNum) => {
		const dataFromPrev = state.signupInput
		console.log('dataFromPrev : ', dataFromPrev)

		const phoneNumber = data.phoneNumber
		console.log(dataFromPrev.businessLicense)

		const cleanedPhoneNumber = phoneNumber.replace(/-/g, '')

		// businessLicense가 빈 객체이거나 null/undefined인 경우 빈 문자열로 변환
		const businessLicenseValue =
			dataFromPrev.businessLicense &&
			typeof dataFromPrev.businessLicense === 'object' &&
			Object.keys(dataFromPrev.businessLicense).length === 0
				? ''
				: (dataFromPrev.businessLicense ?? '')

		// 회원번호 인증이 성공한 경우에만 회원번호 값 사용
		const isMemberNumberVerified = memberNumStatus === 'success'
		const membershipNumberValue = isMemberNumberVerified ? data.memberNumber : undefined

		console.log('memberNumStatus:', memberNumStatus)
		console.log('data.memberNumber:', data.memberNumber)
		console.log('isMemberNumberVerified:', isMemberNumberVerified)
		console.log('membershipNumberValue:', membershipNumberValue)

		const finalSubmissionData = {
			name: data.name,
			firstName: dataFromPrev.firstname,
			lastName: dataFromPrev.lastname,
			email: dataFromPrev.email,
			password: dataFromPrev.password,
			phone: cleanedPhoneNumber,
			notification: dataFromPrev.message,
			point: 0,
			userType: 'tourPro',
			profileType: 'unknown',
			tourType: data.association,
			fullMembershipNumber: membershipNumberValue,
			mainSponsorId: dataFromPrev.mainSponsor
				? parseInt(dataFromPrev.mainSponsor)
				: undefined,
			agencyId: dataFromPrev.agency ? parseInt(dataFromPrev.agency) : undefined,
			businessLicense: businessLicenseValue,
			careerLevel: dataFromPrev.proCareer,
		}
		console.log('최종데이터 : ', finalSubmissionData)

		try {
			const response = await registerTourPro(finalSubmissionData)
			console.log('API 응답 성공:', response)
			console.log('approval_status:', response.approval_status)

			// 회원번호 인증이 성공한 경우 강제로 승인 처리
			const isApproved =
				response.approval_status === 'approved' || memberNumStatus === 'success'
			console.log('isApproved:', isApproved, 'memberNumStatus:', memberNumStatus)

			if (isApproved) {
				console.log('승인된 사용자 - 자동 로그인 시작')
				const signInResponse = await signin(dataFromPrev.email, dataFromPrev.password)
				console.log('자동 로그인 시도중')
				console.log('signInResponse:', signInResponse)

				// 토큰과 사용자 정보 저장 (useAuthStatus 훅 사용)
				const { token, user } = signInResponse
				console.log('토큰과 사용자 정보:', { token, user })
				setAuth(token, user)
				console.log('온보딩 페이지로 이동')
				navigate('/onboarding/select-tournament')
			} else {
				console.log('가입 대기 중인 상태에요. approval_status:', response.approval_status)
				setIsModalOpened(true)
			}
		} catch (error) {
			console.error('API 요청 실패:', error)
			// 에러 응답 확인 (서버에서 보낸 에러 메시지 등)
			if (error.response) {
				console.error('응답 데이터:', error.response.data)
				console.error('응답 상태:', error.response.status)
				console.error('응답 헤더:', error.response.headers)
			} else if (error.request) {
				// 요청이 전송되었지만 응답을 받지 못함 (예: 네트워크 오류)
				console.error('응답을 받지 못했습니다:', error.request)
			} else {
				// 요청 설정 중 오류 발생
				console.error('요청 설정 오류:', error.message)
			}
		}
	}

	const handleVerificationSuccess = useCallback(
		(info) => {
			setValue('name', info.name)
			setValue('phoneNumber', info.phoneNumber)
		},
		[setValue],
	)

	const association = watch('association')
	const memberNumberValue = watch('memberNumber')
	const nameValue = watch('name')

	const toggleOption = [
		{ value: 'KPGA', label: 'KPGA(남자)' },
		{ value: 'KLPGA', label: 'KLPGA(여자)' },
	]

	// 폼 제출 핸들러 - submitType에 따라 처리
	const handleFormSubmit = useCallback(
		(data) => {
			// submitType이 2일 때는 회원번호 필드 에러를 무시하고 제출
			if (submitType === 2) {
				clearErrors('memberNumber')
				onSubmitFinalData(data, 2)
			} else {
				onSubmitFinalData(data, 1)
			}
		},
		[submitType, clearErrors, onSubmitFinalData],
	)

	// submitType이 2일 때는 회원번호 필드 검증을 건너뛰는 커스텀 핸들러
	const handleFormSubmitWithValidation = useCallback(
		(e) => {
			e.preventDefault()
			if (submitType === 2) {
				// 회원번호 필드 에러를 먼저 지우고
				clearErrors('memberNumber')
				// 회원번호를 제외한 필드만 검증
				trigger(['name', 'phoneNumber', 'association']).then((isValid) => {
					if (isValid) {
						const currentData = watch()
						onSubmitFinalData(currentData, 2)
					}
				})
			} else {
				// 일반 제출 - 모든 필드 검증
				handleSubmit(handleFormSubmit)(e)
			}
		},
		[
			submitType,
			clearErrors,
			trigger,
			watch,
			onSubmitFinalData,
			handleSubmit,
			handleFormSubmit,
		],
	)

	return (
		<div className={styles.container}>
			<form className={styles.mainForm} onSubmit={handleFormSubmitWithValidation}>
				<div className={styles.title}>투어프로 회원가입</div>
				<div className={styles.associationSection}>
					<div className={styles.associationLabel}>소속협회</div>
					<Controller
						name="association"
						control={control}
						render={({ field }) => (
							<div className={styles.tabContainer}>
								<button
									type="button"
									className={`${styles.tabItem} ${field.value === 'KPGA' ? styles.activeTabItem : ''}`}
									onClick={() => field.onChange('KPGA')}
									aria-pressed={field.value === 'KPGA'}
									title="KPGA">
									<img
										src="/images/kpga-ci.png"
										alt="KPGA"
										className={styles.leagueLogo}
									/>
								</button>
								<button
									type="button"
									className={`${styles.tabItem} ${field.value === 'KLPGA' ? styles.activeTabItem : ''}`}
									onClick={() => field.onChange('KLPGA')}
									aria-pressed={field.value === 'KLPGA'}
									title="KLPGA">
									<img
										src="/images/klpga-ci.png"
										alt="KLPGA"
										className={styles.leagueLogo}
									/>
								</button>
							</div>
						)}
					/>
				</div>
				<SelfVerification
					verifiedStatus={verifiedStatus}
					changeVerifiedStatus={setVerifiedStatus}
					onVerificationSuccess={handleVerificationSuccess}></SelfVerification>
				<MembershipNumber
					setSubmitType={setSubmitType}
					verifiedStatus={verifiedStatus}
					memberNumStatus={memberNumStatus}
					changeMemberNumStatus={setMemberNumStatus}
					association={association}
					memberNumberValue={memberNumberValue}
					name={nameValue}
					changeIsModalOpened={setIsModalOpened}
					register={register}
					isValid={isValid}
					errors={errors}
					trigger={trigger}
					clearErrors={clearErrors}
					setValue={setValue}></MembershipNumber>
				{/* MembershipNumber 내부에 제출 버튼이 있으므로 여기에는 따로 버튼을 두지 않습니다. */}
				<RegisterNoticeModal
					setSubmitType={setSubmitType}
					isOpen={isModalOpened}
					changeIsModalOpened={setIsModalOpened}
					onFormSubmit={handleSubmitWithoutMemberNumber} // 멤버 넘버를 제외한 유효성 검사
					onFinalDataSubmit={onSubmitFinalData}></RegisterNoticeModal>
			</form>

			<div>
				{/*nice 서버에 submit할 form*/}
				<form
					name="form"
					id="form"
					action="https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb">
					<input type="hidden" id="m" name="m" value="service" />
					<input type="hidden" id="token_version_id" name="token_version_id" value="" />
					<input type="hidden" id="enc_data" name="enc_data" />
					<input type="hidden" id="integrity_value" name="integrity_value" />
					<input type="hidden" name="ReturnURL" value="" />
				</form>
			</div>
		</div>
	)
}

export default SignupVerificationForm
